import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e319d71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "on-monitor" }
const _hoisted_2 = { class: "first-space" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<aside data-v-0e319d71><h1 class=\"theme-word\" data-v-0e319d71><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/logo1.svg\" alt=\"logo\" data-v-0e319d71>八爪畅学 </h1><h2 data-v-0e319d71>2亿+ 孩子和青少年的素质教育训练场</h2><p data-v-0e319d71>现在就出发，一起抵达更美的远方</p><div class=\"liner\" data-v-0e319d71></div><div class=\"code clearfix\" data-v-0e319d71><div class=\"fl\" data-v-0e319d71><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/wxcode.png\" alt=\"八爪畅学小程序\" data-v-0e319d71><p data-v-0e319d71>八爪畅学小程序</p></div></div></aside><img src=\"https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/phone1.png\" alt=\"phone\" class=\"phone\" data-v-0e319d71>", 2)
const _hoisted_6 = { class: "four-question" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("span", null, "5包服务，助力孩子五育培养，升学成长")
], -1))
const _hoisted_8 = { class: "second-space" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "third-space" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/linkbg1.png",
      class: "left-img"
    }),
    /*#__PURE__*/_createElementVNode("aside", null, [
      /*#__PURE__*/_createElementVNode("h1", null, [
        /*#__PURE__*/_createElementVNode("span", null, "2023，八爪和你一起，开启素质教育美好旅程")
      ]),
      /*#__PURE__*/_createElementVNode("img", { src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/linkcode.png" }),
      /*#__PURE__*/_createElementVNode("p", null, "扫一扫关注八爪畅学用户端小程序")
    ])
  ])
], -1))
const _hoisted_11 = { class: "on-mobile" }
const _hoisted_12 = { class: "product-tab" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "theme-word" }, "八爪畅学用户端", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "2亿+ 孩子和青少年的", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "素质教育训练场", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "现在就出发，一起抵达更美的远方", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/phone1.png" }, null, -1))
const _hoisted_18 = { class: "packages" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "phone-product-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "5包服务，助力孩子五育培养，升学成长")
], -1))
const _hoisted_20 = { class: "advantages" }
const _hoisted_21 = { class: "ul-li" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "together" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "2023，八爪和你一起，开启素质教育美好旅程"),
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/user.jpg",
      alt: "八爪畅学用户端小程序"
    }),
    /*#__PURE__*/_createElementVNode("p", null, "扫一扫关注八爪畅学用户端小程序")
  ])
], -1))

import { ref } from 'vue';
  import { useRouter } from "vue-router";
  import { wxSchema } from "@/request/api"

export default /*#__PURE__*/_defineComponent({
  __name: 'consumer',
  setup(__props) {

  const router = useRouter();

// 跳转微信用户小程序入驻页
const userPath = ref("");
let data = {
  type: 0,
  path: "/pages/index/index",
  env_version: "release",
}
wxSchema(data).then((res:any)=>{
  userPath.value = res.openlink
})

// 移动端-跳转路由
const targetPage = (name:string)=>{
  router.push({ name });
}
  // 5包服务，助力孩子五育培养，升学成长
  const packageList = ref([
    {title:'课程包',en:'Courses package'},
    {title:'商品包',en:'Commodity package'},
    {title:'数据包',en:'Data package'},
    {title:'会员包',en:'Membership package'},
    {title:'升学助力包',en:'Learning assistance package'},
  ])
  // 优势列表
  const advantageList = ref([
    {
      title:'灵活检索，帮助家长快速找到心仪机构',
      desc:'多种检索方式，叠加推荐算法，辅助家长精准决策',
      picture:'https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/con1.png',
      children: ['精准搜索','组合搜索','特色标签','附近发现']
    },
    {
      title:'互动中心',
      desc:'多种活动场域，边玩边学边成长',
      picture:'https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/con2.png',
      children: ['投票中心','成长计划','微信社群','社区互动']
    },
    {
      title:'福利中心',
      desc:'平台补贴，推出多重福利，家长省心、更省钱',
      picture:'https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/con3.png',
      children: ['新人礼券','邀请返利','学习基金','积分商城']
    },
    {
      title:'成长中心',
      desc:'赛事活动、成长照片，一路陪伴，一路记载',
      picture:'https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/product/con4.png',
      children: ['赛事活动','学习照片','考证考级','成长视频']
    },
  ])

  const toWxUser = ()=>{
    userPath.value && window.open(userPath.value)
  }
  
return (_ctx: any,_cache: any) => {
  const _directive_fadein = _resolveDirective("fadein")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageList.value, (item, i) => {
                return (_openBlock(), _createElementBlock("li", { key: i }, [
                  _createElementVNode("h1", null, _toDisplayString(item.title), 1),
                  _createElementVNode("h3", null, _toDisplayString(item.en), 1),
                  _createElementVNode("p", null, _toDisplayString('0'+(i+1)), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(advantageList.value, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "container",
            key: i
          }, [
            _createElementVNode("aside", null, [
              _createElementVNode("h1", null, _toDisplayString(item.title), 1),
              _createElementVNode("p", null, _toDisplayString(item.desc), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (elem, e) => {
                return (_openBlock(), _createElementBlock("ul", { key: e }, [
                  _createElementVNode("li", null, _toDisplayString(elem), 1)
                ]))
              }), 128))
            ]),
            _withDirectives(_createElementVNode("img", {
              src: item.picture
            }, null, 8, _hoisted_9), [
              [_directive_fadein]
            ])
          ]))
        }), 128))
      ]),
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("ul", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("li", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (targetPage('mechanism')))
        }, "八爪畅学机构端"),
        _createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (targetPage('serve')))
        }, "八爪优服")
      ]),
      _createElementVNode("div", { class: "grounds" }, [
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _hoisted_17,
        _createElementVNode("button", {
          class: "phone-product-btn",
          onClick: toWxUser
        }, "立即打开")
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageList.value, (item, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, [
              _createElementVNode("h1", null, _toDisplayString(item.title), 1),
              _createElementVNode("p", null, _toDisplayString(item.en), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(advantageList.value, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "container",
            key: i
          }, [
            _createElementVNode("h1", null, _toDisplayString(item.title), 1),
            _createElementVNode("p", null, _toDisplayString(item.desc), 1),
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (elem, e) => {
                return (_openBlock(), _createElementBlock("span", { key: e }, _toDisplayString(elem), 1))
              }), 128))
            ]),
            _withDirectives(_createElementVNode("img", {
              src: item.picture
            }, null, 8, _hoisted_22), [
              [_directive_fadein]
            ])
          ]))
        }), 128))
      ]),
      _hoisted_23
    ])
  ], 64))
}
}

})